import React, { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import Header from '../components/Header';

import backarrow from '../assets/arrow-back-basic-svgrepo-com.svg';
import notfound from '../assets/file-without-extension-svgrepo-com.svg';
import playIcon from '../assets/play-icon.svg'; // Add a play icon for videos
import view from '../assets/view.svg'; // Add a play icon for videos
import download from '../assets/download.svg'; // Add a play icon for videos
import phone from '../assets/cellphone.svg'
import Icon_Contacts from '../assets/user-svgrepo-com.svg'




async function getFiles(type, userId) {
    console.log("Fetching files for:", type, userId);

    try {
        const res = await fetch(`https://apiv2.mobileartsme.com/sb_gets3files?type=${type}&userId=${userId}`);
        const response = await res.json();
        console.log("API Response:", response);

        return response.Files || []; // Ensure it always returns an array
    } catch (error) {
        console.error("Error fetching files:", error);
        return []; // Return an empty array on error
    }
}







function Details() {
    const [files, setFiles] = useState([]); // Ensuring files is NEVER undefined
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true); // Start with loading as true


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedVideo, setSelectedVideo] = useState('');

    const openModal = (videoUrl) => {
        setSelectedVideo(videoUrl);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedVideo('');
    };



    const type = searchParams.get("type");
    const typename = searchParams.get("typename");
    const userId = localStorage.getItem("Sb_UserId");

    useEffect(() => {
        if (type && userId) {
            async function fetchFiles() {
                setLoading(true); // Set loading to true before fetching
                const fileData = await getFiles(type, userId);
                console.log("LL :", fileData); // Debugging
                setFiles(fileData); // Update state with fetched files
                setLoading(false); // Set loading to false after fetching is done
            }
            fetchFiles();
        }
    }, [type, userId]);

    return (
        <div>
            <Header />

            {loading ? (
                <div className='w-100 d-flex flex-row align-items-center justify-content-center' style={{ height: '20vh' }}>
                    <div className="loader"></div>
                </div>
            ) : (
                <div className='detail-body container mt-3'>
                    <div className='d-flex flex-row justify-content-between align-items-center' style={{ borderBottom: '1px solid black' }}>
                        <h3>{typename}</h3>
                        <p style={{ color: '#3859C5', cursor: 'pointer' }} onClick={() => window.history.back()}>
                            <img style={{ width: '30px' }} src={backarrow} alt="Back" /> Back
                        </p>
                    </div>

                    <div className="files-list mt-3">
                        {files.length > 0 ? (
                            <>
                                {typename === "Documents" && (
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Size</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {files.map((file, index) => (
                                                <tr key={index}>
                                                    <td>{file.FileName}</td>
                                                    <td>{(file.Size / 1024).toFixed(2)} KB</td>
                                                    <td className='d-flex flex-row gap-2' >
                                                        <a href={file.ObjectData} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-primary">
                                                            <img style={{ width: '20px' }} src={download} />
                                                        </a>
                                                        <a href={file.ObjectData} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-primary">
                                                            <img style={{ width: '20px' }} src={view} />
                                                        </a>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}

                                {typename === "Images" && (
                                    <div className="image-gallery">
                                        {files.map((file, index) => (

                                            <img src={file.ObjectData} alt={file.FileName} className="img-fluid rounded shadow-sm" />

                                        ))}
                                    </div>
                                )}

                                {typename === "Videos" && (
                                    <div className="video-gallery">
                                        {files.map((file, index) => (
                                            <div key={index} className="video-item">
                                                <a href="#" onClick={() => openModal(file.ObjectData)}>
                                                    <img src={playIcon} className="play-icon" alt="Play Video" />
                                                    <video>
                                                        <source src={file.ObjectData} type="video/mp4" />
                                                    </video>
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                )}


                                {typename === "Audio" && (
                                    <div className="audio-list">
                                        {files.map((file, index) => (
                                            <div key={index} className="audio-item d-flex align-items-center gap-3">
                                                <audio controls>
                                                    <source src={file.ObjectData} type="audio/mpeg" />
                                                    Your browser does not support the audio element.
                                                </audio>
                                                <p>{file.FileName}</p>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {typename === "Contacts" && (
                                    <div className="contact-list">
                                        {files.map((file, index) => {
                                            const contacts = JSON.parse(file.ObjectData); // Parse the JSON string
                                            return contacts.map((contact, contactIndex) => (
                                                <div key={contactIndex} className="contact-item">

                                                    <p style={{ color: 'black' }}>
                                                        <img style={{ width: '30px' }} src={Icon_Contacts} />
                                                        {contact.contactName}</p>

                                                    <p style={{ color: 'black' }}>

                                                        {contact.contactPhoneNumber}</p>
                                                </div>
                                            ));
                                        })}
                                    </div>
                                )}


                            </>
                        ) : (
                            <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: '30vh' }}>
                                <h2>No Items Found</h2>
                                <img style={{ width: '100px' }} src={notfound} alt="Not Found" />
                            </div>
                        )}
                    </div>
                </div>
            )}


            {isModalOpen && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-button" onClick={closeModal}>X</button>
                        <video controls autoPlay>
                            <source src={selectedVideo} type="video/mp4" />
                        </video>
                    </div>
                </div>
            )}

        </div>
    );
}

export default Details;
